module.exports = __webpack_public_path__ + "img/list.2b7ff699.svg";